import { Component } from "react";
import Loader from "../../../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import ExhibitorHeader from "../../../../../common_components/exhibitor_module_header";
import ExhibitorDrawer from "../../../../../common_components/exhibitor_module_drawer";
import ExhibitorTopMenu from "../../../../../common_components/exhibitor_module_topmenu";
import { withRouter } from "../../../../../utils/withRouter";
import { connect } from "react-redux";
import { toastError, toastSuccess } from "../../../../../utils/constants";
import { getPowerConnectionList_action, submitPowerConnection_action, getPowerConnectionDetails_action } from '../../../../../actions/exhibitor_module_actions/manual_Forms_actions/forms_actions/power_connection_action/power_connection_action'
import Modal from "react-modal";
import { data } from "jquery";
// 
class PowerConnection extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            PowerConnectionList: [],
            Is_Agree: false,
            Remark: '',
            CGST: '',
            SGST: '',
            Is_AgreeErr: ''

        }
        this.getPowerConnectionList = this.getPowerConnectionList.bind(this)
        this.calculateTotals = this.calculateTotals.bind(this)

    }

    componentDidMount() {
        this.getPowerConnectionList()
        setTimeout(() => {
            this.getPowerConnectionDetails()
        }, 100);
    }

    getPowerConnectionDetails() {
        this.setState({ isLoading: true })
        this.props
            .getPowerConnectionDetails_action()
            .then((data) => {
                if (data.error != 1) {
                    if (data.data != '') {
                        this.setState({
                            PowerConnectionList: data.data,
                            CGST: data.data[0]['CGST'],
                            SGST: data.data[0]['SGST'],
                            Remark: data.data[0]['Remark'],
                            Is_Agree: data.data[0]['Is_Agree']
                        })
                        console.log("data.data[0]['Is_Agree']", data.data[0]['Is_Agree'])
                    }
                    this.setState({ isLoading: false })
                }
                else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((e) => {
                console.log(e);
            });
    }

    getPowerConnectionList() {
        this.setState({ isLoading: true })
        this.props
            .getPowerConnectionList_action()
            .then((data) => {
                if (data.error != 1) {
                    console.log("hello", data.data)
                    data.data.map((item) => {
                        item['Amount'] = item['Rates']
                    })
                    this.setState({ PowerConnectionList: data.data, CGST: data.data[0]['CGST'], SGST: data.data[0]['SGST'] })
                    this.setState({ isLoading: false })
                }
                else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((e) => {
                console.log(e);
            });
    }

    submitPowerConnection() {
        const { PowerConnectionList, Remark, Is_Agree } = this.state
        const { totalAmount } = this.calculateTotals

        const newArray = []

        PowerConnectionList.map((data, i) => {
            newArray.push(
                {
                    'ServiceID': data.ServiceID,
                    'Rates': data.Rates,
                    'Quantity': data.Quantity != '' ? parseInt(data.Quantity) : 0,
                    'Amount': data.Amount,
                }
            )
        })
        this.inputValidate()
        this.setState({ isLoading: true })
        if (Is_Agree) {
            this.props
                .submitPowerConnection_action(Remark, Is_Agree == true ? 1 : 0, newArray)
                .then((data) => {
                    if (data.error != 1) {
                        setTimeout(() => {
                            this.props.navigate('/manualForms')
                            this.setState({ isLoading: false })
                        }, 100);
                    }
                    else {
                        this.setState({ isLoading: false })
                        toastError(data.msg)
                    }
                })
                .catch((e) => {
                    console.log(e);
                });
        } else {
            this.setState({ isLoading: false })
        }
    }

    calculateTotals() {
        try {
            const { PowerConnectionList } = this.state
            let totalAmount = 0
            PowerConnectionList.forEach((data) => {
                totalAmount += Number(data.Amount)
            });
            return {
                totalAmount,
            };

        } catch (e) {
            console.log('exception : ', e);
        }

    }

    handleCancel() {
        this.props.navigate('/manualForms')
    }

    enterQuantity(e, index) {
        const { PowerConnectionList } = this.state
        const list = [...PowerConnectionList]
        for (let i = 0; i < list.length; i++) {
            if (i == index) {
                console.log("PowerConnectionList", e.target.value)
                list[i]['Quantity'] = e.target.value
                if (e.target.value != '' && e.target.value != 0) {
                    list[i]['Amount'] = e.target.value * list[i]['Rates']
                } else {
                    list[i]['Amount'] = list[i]['Rates']
                }
            }
        }
        this.setState({
            PowerConnectionList: list
        })
    }

    inputValidate() {
        const { Is_Agree } = this.state

        if (Is_Agree == 0 || Is_Agree == false) {
            this.setState({ Is_AgreeErr: 'kindly agree to terms and condition' })
        }
    }

    render() {
        const { isLoading, Is_Agree, Remark, PowerConnectionList, SGST, CGST, Is_AgreeErr } = this.state

        const { totalAmount } = this.calculateTotals()
        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}
                <ToastContainer />
                <ExhibitorHeader />
                <ExhibitorDrawer />
                <div className="main-content app-content mt-0 with-dr-container">
                    <div className="">
                        <div className="row">
                            <ExhibitorTopMenu />
                        </div>
                        <div className=" mt-2">
                            <div className="row">
                                <div class="card rounded-0 pt-1">
                                    <div class="card-header p-3" style={{ paddingleft: "7px !important" }}>
                                        <h3 class="card-title" style={{ fontsize: "15px" }}>Power Connection  Guideline</h3>
                                    </div>
                                    <div class="card-body p-1 m-2">
                                        <p>1) Exhibitors under Bare Space category are required to apply for power supply and pay electricity connection/consumption charges on the basis of required connected load for machinery, including lighting and air-conditioning. Exhibitors’ should inform their power requirements along with the payment towards power charges before <strong style={{ color: "#0056ff" }}>31.09.2021</strong>.
                                        </p>
                                        <p>2)Exhibitors should note that 1kw supply/outlet is compulsory in every single stall as a facility for lighting. Every exhibitor must submit their layout plan with indication of point of power supply.
                                        </p>
                                        <p>3) Exhibitors under Shell Scheme package would be provided with a plug point socket and a switch for a 240 V, 6 Amp A.C. supply. Consumption of power through this plug point for the connected load upto1 kw is included in the cost of shell scheme package. However, additional power would be made available to them on extra payment.
                                        </p>
                                        <p>4) The exhibitor requiring supply at voltage level other than above shall make necessary arrangement for the level matching equipment such as transformer, voltage stabilizer, inverter etc. to match the supply voltage level to their load.</p>
                                        <p>5) Exhibitors shall bring their own electrical cables, wires, sockets, international electrical adaptor to connect their electrical installation.</p>
                                        <p>6) The Exhibition authority arrange for supply of power will be entrusted with the authority for regulating and controlling the power supply to the exhibition halls and individual stalls. </p>
                                        <p>7) Power supply In KICC :single phase 240 v and three phase 415v</p>

                                        <p>If details of requirements along with the payment from Exhibitors, received by INDIA ITME Society after <strong>deadline (30.09.2021), then additional surcharge of 25% of basic rates shall be applicable to the Exhibitors</strong>.</p>
                                        <p><strong>The tariff for electric power will be as under:</strong></p>
                                        <p><strong>Connection/Consumption charges for power supply to the exhibitors will be</strong></p>
                                        <p>1) For Indian exhibitors Rs 0000/- per KW of connected load including lighting and air conditioning load. Plus GST @ 18% (as per Government rule) or as applicable is payable with all the payments will not be refunded.</p>
                                        <p>2) For Foreign exhibitors US Dollar 00/- per KW of connected load including lighting and air conditioning load. Plus GST @ 18% (as per Government rule) or as applicable is payable with all the payments will not be refunded.</p>
                                        <p>3) The power supply will be authorized by the Exhibition Authority after prescribed charges are received latest by 00.00.000.</p>
                                        <p>For more details or any queries please contact: itme@itme-africa.com </p>
                                        <div class="table-responsive">
                                            <table class="table border text-nowrap text-md-nowrap table-bordered mb-0 mt-1">
                                                <thead>
                                                    <tr>
                                                        <th>Description of Service</th>
                                                        <th>Rates (INR)</th>
                                                        <th>Quantity</th>
                                                        <th>Amount(INR)</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        PowerConnectionList.length > 0 && PowerConnectionList != null ? (
                                                            PowerConnectionList.map((data, i) => (
                                                                <>
                                                                    <tr>
                                                                        <td>{data.Description}</td>
                                                                        <td>{data.Rates}</td>
                                                                        <td>
                                                                            <input type="text" class="form-control"
                                                                                value={data.Quantity}
                                                                                onChange={(e) => this.enterQuantity(e, i)}
                                                                            />
                                                                        </td>
                                                                        <td>{data.Amount}</td>
                                                                    </tr>
                                                                </>
                                                            ))
                                                        ) : <></>
                                                    }
                                                    <tr>
                                                        <td colspan="2"></td>
                                                        <td><strong>Total</strong></td>
                                                        <td><strong>{totalAmount}</strong></td>
                                                    </tr>
                                                    <tr>
                                                        <td colspan="2"></td>
                                                        <td><strong>CGST @ {CGST}%</strong></td>
                                                        <td><strong>{(CGST / 100) * totalAmount}</strong></td>
                                                    </tr>
                                                    <tr>
                                                        <td colspan="2"></td>
                                                        <td><strong>SGST @ {SGST}%</strong></td>
                                                        <td><strong>{(SGST / 100) * totalAmount}</strong></td>
                                                    </tr>
                                                    <tr style={{ backgroundcolor: "#eee" }}>
                                                        <td colspan="2"></td>
                                                        <td><strong>Grand Total</strong></td>
                                                        <td><strong>{
                                                            (CGST / 100) * totalAmount + (SGST / 100) * totalAmount + totalAmount
                                                        }</strong></td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                <div class="row m-1">
                                    <form>
                                        <label>Remark</label>
                                        <textarea class="form-control"
                                            value={Remark}
                                            onChange={(e) => this.setState({ Remark: e.target.value })}
                                            rows="3">
                                        </textarea>
                                        <label class="d-flex mt-1" style={{ lineheight: "15px;" }}>
                                            <input type="checkbox"
                                                checked={Is_Agree}
                                                onChange={(e) => this.setState({ Is_Agree: e.target.checked, Is_AgreeErr: '' })}
                                            />
                                            We hereby read &amp; understood the above mentioned clauses &amp; consequences. We accept &amp; agree to abide by the same.</label>{<span className='text-danger text-start text-left d-block mt-1'>{Is_AgreeErr}</span>}
                                    </form>
                                </div>
                            </div>
                            <div class='d-flex m-3'>
                                <button
                                    type="button"
                                    className="btn btn-primary rounded-0 d-block mt-3 mb-3"
                                    style={{ marginRight: 10 }}
                                    onClick={() => this.submitPowerConnection()}
                                >
                                    Submit
                                </button>
                                <button className="btn rounded-0 d-block mt-3 mb-3 apper-cancel" onClick={() => this.handleCancel()}>Back</button>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}

export default withRouter(connect(null, { getPowerConnectionList_action, submitPowerConnection_action, getPowerConnectionDetails_action })(PowerConnection));